import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Header, Eyebrow } from 'formlabs-web-components/Type';

import Card from './Card';

const CardList = ({ cards }) =>
  cards.map(({ image, imageAlt, url, eyebrowText, body, caption }, index) => (
    <Card
      key={index}
      image={image}
      imageAlt={imageAlt}
      url={url}
      imageConstraint="300px"
      imagePosition="left"
      bgColor="transparent-black"
      padding="35px 0"
      hover="light-grey"
    >
      <Eyebrow color="blue">{eyebrowText}</Eyebrow>
      <Header level={4} displayAs={4} weight={400}>
        {caption}
      </Header>
      <p>{body}</p>
    </Card>
  ));

export default DisplayComponent(CardList);
